import { Power0, Power2 } from 'gsap'
import TimelineMax from 'gsap/TimelineMax'

class SiteMenu {
  constructor () {
    this.$el = $('.site-menu')
    this.$toggle = $('.site-menu-toggle')
    this.$overlay = $('#site-menu-overlay')
    this.visible = false
    this.timeline = new TimelineMax()
    this.toggle = this.toggle.bind(this)

    $('.site-menu-toggle').click(() => { this.toggle('auto') })
    $('#site-menu-overlay').click(() => { this.toggle(false) })
  }

  toggle (show) {
    show = typeof show === 'undefined' || show === 'auto' ? !this.visible : show
    if (show === this.visible) {
      return
    }
    this.$toggle.toggleClass('toggle-x--close', show)
    $('html, body').css('overflow', show ? 'hidden' : 'visible')
    this.visible = !this.visible
    $('body').trigger('siteMenuToggle', [show])
    if (show) {
      this.timeline
        .clear()
        .to(this.$el, 0.4, { x: '0%', ease: Power2.easeOut }, 0)
        .fromTo(this.$el.find('.site-menu__inner'), 0.4, { x: '-60%' }, { x: '0%', ease: Power2.easeOut }, 0)
        .fromTo(this.$el.find('.site-menu__inner'), 0.4, { autoAlpha: 0 }, { autoAlpha: 1, ease: Power0.easeNone }, 0.2)
        .to(this.$overlay, 0.4, { autoAlpha: 1, ease: Power0.easeNone }, 0)
    } else {
      this.timeline
        .clear()
        .to(this.$el, 0.4, { x: '100%', ease: Power2.easeOut }, 0)
        .to(this.$el.find('.site-menu__inner'), 0.4, { x: '-60%', ease: Power2.easeOut }, 0)
        .to(this.$el.find('.site-menu__inner'), 0.4, { autoAlpha: 0, ease: Power0.easeNone }, 0)
        .to(this.$overlay, 0.4, { autoAlpha: 0, ease: Power0.easeNone }, 0)
    }
  }
}

export default SiteMenu



// WEBPACK FOOTER //
// ./scripts/components/SiteMenu.js